'use strict';

const VenmoExpressCheckout = require('./venmoExpressCheckout');

const requestHelper = require('../../paypal/helpers/payPalRequestsHelperGlobal');

/**
 * A class represents Venmo Product pages functionality
 */
class ProductPage extends VenmoExpressCheckout {
    constructor(pageFlow) {
        super(pageFlow);

        this.isQuickView = Boolean(this.button.closest('.js-braintree-pvp-button-global'));
    }

    /**
     * On Venmo button click
     * Inherits the VenmoExpressCheckout class
     * @param {string} selector - Button selector
     */
    async onClick(selector) {
        await requestHelper.addProductToCart(selector, this.configs.pageFlow);

        super.onClick();
    }

    /**
     * Initiates the Venmo display behavior on the product pages
     */
    initButtonDisplayBehavior() {
        const generalButtonDisplayBehavior = require('../../generalButtonDisplayBehavior');

        this.isQuickView
            ? generalButtonDisplayBehavior.initProductViewPage(this.buttonSelector)
            : generalButtonDisplayBehavior.initProductPage(this.buttonSelector);
    }

    /**
     * Initiates the base functionality for product pages
     * Inherits the VenmoExpressCheckout class
     */
    async init() {
        await super.init();

        this.initButtonDisplayBehavior();
    }
}

module.exports = ProductPage;
